<div class="d-flex justify-content-center align-items-center vh-100 bg-light">
  <div class="card shadow-lg p-4" style="width: 400px; border-radius: 1rem;">
    <div class="card-body">
      <div class="mx-auto text-center w-50">
        <img src="images/logo/Referio.png" alt="Logo" style="width: 100px; height: auto;" />
      </div>

      <h3 class="text-center mb-4">Connexion</h3>

      <form (ngSubmit)="onSubmit()" #signinForm="ngForm">
        <!-- Email -->
        <div class="mb-3">
          <label for="email" class="form-label fw-semibold text-dark small">Adresse e-mail</label>
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0" style="border-radius: 0.75rem 0 0 0.75rem;">
              <i class="bi bi-envelope text-muted"></i>
            </span>
            <input type="email" id="email" class="form-control border-start-0 bg-light ps-0"
              style="border-radius: 0 0.75rem 0.75rem 0;" name="email" [(ngModel)]="credentials.email"
              placeholder="exemple@mail.com" required />
          </div>
        </div>

        <div class="mb-3">
          <label for="password" class="form-label fw-semibold text-dark small">Mot de passe</label>
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0" style="border-radius: 0.75rem 0 0 0.75rem;">
              <i class="bi bi-lock text-muted"></i>
            </span>
            <input type="password" id="password" class="form-control border-start-0 border-end-0 bg-light ps-0"
              name="password" [(ngModel)]="credentials.password" placeholder="••••••••" required />
            <button class="btn bg-light border-start-0 text-muted" type="button"
              style="border-radius: 0 0.75rem 0.75rem 0;" (click)="togglePassword()">
              <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>
        </div>

        <!-- Mot de passe oublié -->
        <div class="text-end mb-3">
          <a routerLink="/forgot-password" class="text-decoration-none small fw-semibold" style="color: #667eea;">
            Mot de passe oublié ?
          </a>
        </div>

        <!-- Message d'erreur -->
        @if (errorMessage) {
        <div class="alert alert-danger border-0 d-flex align-items-center" role="alert" style="border-radius: 0.75rem;">
          <i class="bi bi-exclamation-circle-fill me-2"></i>
          <span class="small">{{ errorMessage }}</span>
        </div>
        }

        <div class="d-flex">
          <button class="btn btn-primary w-100 mt-3" type="submit" [disabled]="signinForm.invalid">
            Se connecter
          </button>
          <a class="btn btn-light w-100 mt-3 mx-3" routerLink="/">
            retour
          </a>
        </div>
      </form>
      <div class="text-center mt-4">
        <small>Pas encore de compte ?</small>
        <a routerLink="/signup" class="ms-1">Créer un compte</a>
      </div>
    </div>
  </div>
</div>